import { render, staticRenderFns } from "./intgsetupEdit.vue?vue&type=template&id=17551e87"
import script from "./intgsetupEdit.vue?vue&type=script&lang=js"
export * from "./intgsetupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports